// extracted by mini-css-extract-plugin
export default {"brandButton":"SavingPets_brandButton__EBRxl","getStartedButton":"SavingPets_getStartedButton__qo+JN","section":"SavingPets_section__DcpBI","counter":"SavingPets_counter__uJc3R"};